module.exports = __webpack_public_path__ + "static/media/save-changes.64d24c7c.png";